import styled from "styled-components";

export const ShiftModalContainer = styled.div`
  width: 100%;
`;

export const ZoneOptions = styled.div`
  background-color: #F5F6F8;
  display: flex;
  align-items: center;
  padding: .5rem 1.5rem;
  border-radius: 10px;
  margin-right: .3rem;
  
  div {
    position: relative;  
  }
  
  i::before {
    color: var(--gray-color);
  }
  
  i.icon-arrow {
    margin-right: .7rem;
  }

  i.icon-arrow::before {
    color: var(--light-gray-color);
    font-size: .4rem;
    font-weight: 600;
  }
  
  select {
    margin-right: 1.5rem;
    border: none;
    background-color: #F5F6F8;
    color: var(--light-gray-color);
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    
    &:focus {
      outline: none;
    }
  }

  select:disabled {
    opacity: .5;
    cursor: not-allowed;
    
    &+i {
      opacity: .5;
    }
  }
`;
